import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {Tabs, Tab} from 'material-ui/Tabs';


import theme from 'theme';

class PageHeader extends Component {
  state = {
    tab: "a"
  };

  static contextTypes = {
      router: PropTypes.object
  };
  
  style =  {
    tab:{ color: theme.palette.textColor },
    inkBarStyle: {height: 3, backgroundColor: theme.palette.primary1Color },
    tabItemContainerStyle: { backgroundColor:theme.palette.alternateTextColor }
  }
  
  handleChange = (e) => {
    this.setState({...this.state, tab:e});
    if (this.props.onNav)
    {    
      this.props.onNav(e);
    }
  }

  openMediagroup = (e) => {
    if (this.props.mediagrouplogo && this.props.mediagrouplogo.key)
    {
      this.context.router.history.push("/mediehus/"+this.props.mediagrouplogo.key);
    }
  }

  renderTabs = () => {
    return _.map(this.props.tabs, (tab) => {
      return <Tab key={tab.key} buttonStyle={{padding: "0 32px"}} style={this.style.tab} label={tab.label}  value={tab.key} />
    });
  }
  
  render() {
    return (
      <div className="page_header">
        { this.props.mediagrouplogo && this.props.mediagrouplogo.logoUrl &&
        <div className="page_header__mediagrouplogo" onClick={this.openMediagroup}>
         <img alt="" src={this.props.mediagrouplogo.logoUrl}  />
         </div>
        }
        <div className="page_header--left" >
        { this.props.logo &&
          <img alt="" src={this.props.logo} onClick={this.props.onLogoClick}/>
        }
        </div>
        <div className="page_header--center" >
          <div>
            <h1>{this.props.title}</h1>
            <h3>{this.props.children}</h3>
          </div>
          <Tabs  inkBarStyle={this.style.inkBarStyle} tabItemContainerStyle={this.style.tabItemContainerStyle}  value={this.state.tab} onChange={this.handleChange} >
            {this.renderTabs()}
          </Tabs>
        </div>
        <div className="page_header--right" >
        </div>
      </div>
    );
  }
}

export default PageHeader;

/*

 */



// WEBPACK FOOTER //
// ./src/components/Page/PageHeader.jsx